import { Button, Dialog, Portal } from '@chakra-ui/react'

interface DeleteAdvisorDialogProps {
  open: boolean
  onClose: () => void
  onDelete: () => void
  loading?: boolean
}

export function DeleteAdvisorDialog({
  open,
  onClose,
  onDelete,
  loading = false,
}: DeleteAdvisorDialogProps) {
  return (
    <Dialog.Root lazyMount open={open} onOpenChange={details => !details.open && onClose()}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Berater löschen</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              Der Berater wird unwiderruflich gelöscht. Möchten Sie den Vorgang fortsetzen?
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant="ghost" onClick={onClose}>
                Abbrechen
              </Button>
              <Button
                variant="subtle"
                colorPalette="red"
                disabled={loading}
                loading={loading}
                onClick={onDelete}
              >
                Berater löschen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
